export const LocalStorageKeys = {
  OptIn: 'optIn',
} as const;
